import { render, staticRenderFns } from "./alm.vue?vue&type=template&id=60b52142"
import script from "./alm.vue?vue&type=script&lang=js"
export * from "./alm.vue?vue&type=script&lang=js"
import style0 from "./alm.vue?vue&type=style&index=0&id=60b52142&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports